
import React from 'react';
import { Button } from '@/components/ui/button';
import { Folder, Plus } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

interface Playlist {
  id: string;
  name: string;
  user_id: string;
  created_at: string;
}

interface VideoPlaylistDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  playlists: Playlist[];
  isLoading: boolean;
  playlistVideos: {[key: string]: string[]};
  videoId: string;
  onAddToPlaylist: (videoId: string, playlistId: string) => void;
  onTogglePlaylistMembership: (videoId: string, playlistId: string) => void;
  onCreateNewPlaylist: () => void;
}

const VideoPlaylistDialog = ({
  isOpen,
  onOpenChange,
  playlists,
  isLoading,
  playlistVideos,
  videoId,
  onAddToPlaylist,
  onTogglePlaylistMembership,
  onCreateNewPlaylist
}: VideoPlaylistDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!isLoading) {
        onOpenChange(open);
      }
    }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Gérer les playlists</DialogTitle>
          <DialogDescription>
            Cliquez sur une playlist pour ajouter ou retirer cette vidéo
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4 space-y-2">
          {isLoading ? (
            <div className="text-center py-4">
              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-youtube-red mx-auto"></div>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                Chargement...
              </p>
            </div>
          ) : playlists.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
                Vous n'avez pas encore de playlists
              </p>
              <Button 
                variant="outline" 
                onClick={onCreateNewPlaylist}
              >
                Créer une playlist
              </Button>
            </div>
          ) : (
            <>
              {playlists.map((playlist) => {
                const isInPlaylist = playlistVideos[playlist.id]?.includes(videoId);
                return (
                  <Button 
                    key={playlist.id}
                    variant={isInPlaylist ? "default" : "outline"}
                    className="w-full justify-start"
                    onClick={() => !isLoading && onTogglePlaylistMembership(videoId, playlist.id)}
                    disabled={isLoading}
                  >
                    <Folder className="mr-2 h-4 w-4" />
                    {playlist.name}
                    {isInPlaylist && (
                      <span className="ml-auto text-xs">
                        ✓ Ajoutée
                      </span>
                    )}
                  </Button>
                );
              })}
              <Button 
                variant="outline" 
                className="w-full justify-start mt-4"
                onClick={onCreateNewPlaylist}
              >
                <Plus className="mr-2 h-4 w-4" />
                Nouvelle playlist
              </Button>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoPlaylistDialog;
